module.exports = __webpack_public_path__ + "img/2x UHF-PS1.730630f4.svg";